import React from 'react';

const FEATURES = [
    { id: 0, text: "USD Account" },
    { id: 1, text: "ACH and Domestic Wires" },
    { id: 2, text: "SWIFT Payments Globally" },
    { id: 3, text: "Cross Border Payments in 11 currencies" },
    { id: 4, text: "Digital Asset Custody" },
    { id: 5, text: "Convert Digital Assets" },
    { id: 6, text: "Instant Peer to Peer transfers" },
    { id: 7, text: "FV Bank Visa Debit Cards" },
];

const PRIME_HIGHLIGHTS = [
    { id: 0, text: "Higher transaction and balance support" },
    { id: 1, text: "Enhanced due diligence for regulated and third-party-funds use cases" },
    { id: 2, text: "Business-type-specific compliance questionnaires" },
    { id: 3, text: "Document collection and KYC requirements matched to your business profile" },
];

const BusinessPlusIntro = ({ v2Type }) => {
    const isPrime = Number(v2Type) === 2;

    if (isPrime) {
        return (
            <div className='pt-3'>
                <p>
                    Business Prime is designed for NBFI businesses, enhanced due diligence, or support for regulated and third-party-funds use cases. On the next pages, we will confirm your business type and collect the information required for your Prime application.
                </p>

                <div className='py-3'>
                    <h3>Business Prime Overview</h3>
                    <ul>
                        {PRIME_HIGHLIGHTS.map((feature) => (
                            <li style={{ fontWeight: 'bold' }} key={feature.id}>{feature.text}</li>
                        ))}
                    </ul>
                </div>

                <p className='bold-text'>
                    Your selected business type will determine which additional Prime pages are shown, such as Money Services Business, Cryptocurrency and Digital Assets Involvement, Fund &amp; Family Offices, and Compliance Details.
                </p>
            </div>
        );
    }

    return (
        <div className='pt-3'>
            <p className=''>
                {"FV Bank offers a full-featured business account with Plus onboarding to qualified applicants. If you are interested in applying for a Plus approval business account (approvals in 3-5 days), you will need to answer a few prequalification questions. These will determine if your application can be processed in our Plus program."}
            </p>

            <div className='py-3'>
                <h3>Business Account Plus Features</h3>
                <ul>
                    {FEATURES.map((feature) => (
                        <li style={{ fontWeight: 'bold' }} key={feature.id}>{feature.text}</li>
                    ))}
                </ul>
            </div>

            
        </div>
    );
};

export default BusinessPlusIntro;
